import React from 'react';
import { getOptimizedImageUrl } from '../hooks/imageHelper';

const OptimizedImage = ({ src, alt, quality = 80, className, priority, ...props }) => {
  const optimizedSrc = getOptimizedImageUrl(src, quality, props);

  return (
    <img 
      src={optimizedSrc} 
//       srcset={`${optimizedSrc} 651w, 
//       ${optimizedSrc} 1302w, 
//       ${optimizedSrc} 1953w`}
sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
width={props.width}
height={props.height}
      alt={alt || "Product Image"} 
      className={className}
      loading="lazy" // Bonus: Speeds up pages by only loading images as users scroll
      {...props} 
    />
  );
};

export default OptimizedImage;